import _classCallCheck from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { PerspectiveCamera, ShaderMaterial, Uniform, Vector2 } from "three";
var fragmentTemplate = "#include <common>\r\n#include <packing>\r\n#include <dithering_pars_fragment>\r\n\r\nuniform sampler2D inputBuffer;\r\nuniform sampler2D depthBuffer;\r\n\r\nuniform vec2 resolution;\r\nuniform vec2 texelSize;\r\n\r\nuniform float cameraNear;\r\nuniform float cameraFar;\r\nuniform float aspect;\r\nuniform float time;\r\n\r\nvarying vec2 vUv;\r\n\r\nfloat readDepth(const in vec2 uv) {\r\n\r\n\t#if DEPTH_PACKING == 3201\r\n\r\n\t\treturn unpackRGBAToDepth(texture2D(depthBuffer, uv));\r\n\r\n\t#else\r\n\r\n\t\treturn texture2D(depthBuffer, uv).r;\r\n\r\n\t#endif\r\n\r\n}\r\n\r\nFRAGMENT_HEAD\r\n\r\nvoid main() {\r\n\r\n\tFRAGMENT_MAIN_UV\r\n\r\n\tvec4 color0 = texture2D(inputBuffer, UV);\r\n\tvec4 color1 = vec4(0.0);\r\n\r\n\tFRAGMENT_MAIN_IMAGE\r\n\r\n\tgl_FragColor = color0;\r\n\r\n\t#include <dithering_fragment>\r\n\r\n}\r\n";
var vertexTemplate = "uniform vec2 resolution;\r\nuniform vec2 texelSize;\r\n\r\nuniform float cameraNear;\r\nuniform float cameraFar;\r\nuniform float aspect;\r\nuniform float time;\r\n\r\nvarying vec2 vUv;\r\n\r\nVERTEX_HEAD\r\n\r\nvoid main() {\r\n\r\n\tvUv = uv;\r\n\r\n\tVERTEX_MAIN_SUPPORT\r\n\r\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\r\n\r\n}\r\n";
/**
 * An effect material for compound shaders.
 *
 * This material supports dithering.
 *
 * @implements {Resizable}
 */

export var EffectMaterial =
/*#__PURE__*/
function (_ShaderMaterial) {
  _inherits(EffectMaterial, _ShaderMaterial);

  /**
   * Constructs a new effect material.
   *
   * @param {Map<String, String>} shaderParts - A collection of shader snippets.
   * @param {Map<String, String>} defines - A collection of preprocessor macro definitions.
   * @param {Map<String, Uniform>} uniforms - A collection of uniforms.
   * @param {Camera} [camera=null] - A camera.
   * @param {Boolean} [dithering=false] - Whether dithering should be enabled.
   */
  function EffectMaterial(shaderParts, defines, uniforms) {
    var _this;

    var camera = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var dithering = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    _classCallCheck(this, EffectMaterial);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EffectMaterial).call(this, {
      type: "EffectMaterial",
      defines: {
        DEPTH_PACKING: "0"
      },
      uniforms: {
        inputBuffer: new Uniform(null),
        depthBuffer: new Uniform(null),
        resolution: new Uniform(new Vector2()),
        texelSize: new Uniform(new Vector2()),
        cameraNear: new Uniform(0.3),
        cameraFar: new Uniform(1000.0),
        aspect: new Uniform(1.0),
        time: new Uniform(0.0)
      },
      fragmentShader: fragmentTemplate.replace(Section.FRAGMENT_HEAD, shaderParts.get(Section.FRAGMENT_HEAD)).replace(Section.FRAGMENT_MAIN_UV, shaderParts.get(Section.FRAGMENT_MAIN_UV)).replace(Section.FRAGMENT_MAIN_IMAGE, shaderParts.get(Section.FRAGMENT_MAIN_IMAGE)),
      vertexShader: vertexTemplate.replace(Section.VERTEX_HEAD, shaderParts.get(Section.VERTEX_HEAD)).replace(Section.VERTEX_MAIN_SUPPORT, shaderParts.get(Section.VERTEX_MAIN_SUPPORT)),
      dithering: dithering,
      depthWrite: false,
      depthTest: false
    }));

    if (defines !== null) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = defines.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var entry = _step.value;
          _this.defines[entry[0]] = entry[1];
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }

    if (uniforms !== null) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = uniforms.entries()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _entry = _step2.value;
          _this.uniforms[_entry[0]] = _entry[1];
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }

    _this.adoptCameraSettings(camera);

    return _this;
  }
  /**
   * The current depth packing.
   *
   * @type {Number}
   */


  _createClass(EffectMaterial, [{
    key: "setSize",

    /**
     * Sets the resolution.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */
    value: function setSize(width, height) {
      width = Math.max(width, 1.0);
      height = Math.max(height, 1.0);
      this.uniforms.resolution.value.set(width, height);
      this.uniforms.texelSize.value.set(1.0 / width, 1.0 / height);
      this.uniforms.aspect.value = width / height;
    }
    /**
     * Adopts the settings of the given camera.
     *
     * @param {Camera} [camera=null] - A camera.
     */

  }, {
    key: "adoptCameraSettings",
    value: function adoptCameraSettings() {
      var camera = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (camera !== null) {
        this.uniforms.cameraNear.value = camera.near;
        this.uniforms.cameraFar.value = camera.far;

        if (camera instanceof PerspectiveCamera) {
          this.defines.PERSPECTIVE_CAMERA = "1";
        } else {
          delete this.defines.PERSPECTIVE_CAMERA;
        }
      }
    }
  }, {
    key: "depthPacking",
    get: function get() {
      return Number.parseInt(this.defines.DEPTH_PACKING);
    }
    /**
     * Sets the depth packing.
     *
     * Use `BasicDepthPacking` or `RGBADepthPacking` if your depth texture
     * contains packed depth.
     *
     * You'll need to call {@link EffectPass#recompile} after changing this value.
     *
     * @type {Number}
     */
    ,
    set: function set(value) {
      this.defines.DEPTH_PACKING = value.toFixed(0);
    }
  }]);

  return EffectMaterial;
}(ShaderMaterial);
/**
 * An enumeration of shader code placeholders.
 *
 * @type {Object}
 * @property {String} FRAGMENT_HEAD - A placeholder for function and variable declarations inside the fragment shader.
 * @property {String} FRAGMENT_MAIN_UV - A placeholder for UV transformations inside the fragment shader.
 * @property {String} FRAGMENT_MAIN_IMAGE - A placeholder for color calculations inside the fragment shader.
 * @property {String} VERTEX_HEAD - A placeholder for function and variable declarations inside the vertex shader.
 * @property {String} VERTEX_MAIN_SUPPORT - A placeholder for supporting calculations inside the vertex shader.
 */

export var Section = {
  FRAGMENT_HEAD: "FRAGMENT_HEAD",
  FRAGMENT_MAIN_UV: "FRAGMENT_MAIN_UV",
  FRAGMENT_MAIN_IMAGE: "FRAGMENT_MAIN_IMAGE",
  VERTEX_HEAD: "VERTEX_HEAD",
  VERTEX_MAIN_SUPPORT: "VERTEX_MAIN_SUPPORT"
};